import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, LeafIcon } from './Icons';
export function HeroSection() {
  return <section className="relative w-full bg-cream overflow-hidden" data-id="element-247">
      {/* Subtle decorative elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-gold/5 rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-248" />
      <div className="absolute bottom-0 left-0 w-48 h-48 bg-sage/5 rounded-full translate-y-1/2 -translate-x-1/2" data-id="element-249" />

      <div className="relative max-w-3xl mx-auto px-5 pt-10 pb-8 md:pt-24 md:pb-20" data-id="element-250">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center" data-id="element-251">
          {/* Small badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-sage-light rounded-full mb-5 md:mb-8" data-id="element-252">
            <LeafIcon className="w-4 h-4 text-sage" data-id="element-253" />
            <span className="text-sm font-medium text-sage-dark font-body tracking-wide" data-id="element-254">
              Protocolo 100% Natural
            </span>
          </div>

          <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-brown-dark leading-tight mb-6" data-id="element-255">
            El Protocolo de Rescate Capilar 60+:{' '}
            <span className="text-gold" data-id="element-256">
              Detén la Caída y el Picor en 7 Días
            </span>
          </h1>

          <h2 className="font-heading text-lg sm:text-xl md:text-2xl font-normal text-brown-medium leading-relaxed mb-6 md:mb-10 italic max-w-2xl mx-auto" data-id="element-257">
            El método de "Enfriamiento Foliar" que apaga la inflamación del
            cuero cabelludo y salva cada hebra sin químicos agresivos ni
            fármacos costosos.
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3,
        ease: 'easeOut'
      }} className="flex justify-center mb-6 md:mb-10" data-id="element-258">
          <div className="relative" data-id="element-259">
            <div className="absolute inset-0 bg-gold/10 rounded-2xl blur-2xl scale-105" data-id="element-260" />
            <img src="https://cdn.magicpatterns.com/uploads/iiF2mmFGqvK9Mcf1hSakcB/hf_20260321_020618_9ff2218b-a4b4-4e31-9978-fbd4808fa095.jpg" alt="Protocolo Rescate Capilar 60+ mostrado en una tablet sobre una superficie de mármol junto a un frasco de suero y hojas de menta" className="relative w-full max-w-md rounded-2xl shadow-2xl" data-id="element-261" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6,
        ease: 'easeOut'
      }} className="text-center" data-id="element-262">
          <a href="#oferta" className="inline-flex items-center gap-3 bg-gold text-white font-body font-semibold text-lg px-8 py-4 rounded-full shadow-lg shadow-gold/25 hover:bg-gold-light hover:shadow-xl hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-gold focus:ring-offset-2 focus:ring-offset-cream" aria-label="Descargar el Protocolo de Rescate Capilar Ahora" data-id="element-263">
            <DownloadIcon className="w-5 h-5" data-id="element-264" />
            Descargar el Protocolo de Rescate Ahora
          </a>
          <p className="mt-4 text-sm text-warm-gray font-body" data-id="element-265">
            Acceso inmediato en formato PDF
          </p>
        </motion.div>
      </div>
    </section>;
}